<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      School Exam
    </button>
    <a-modal v-model="visible" title="Add a new school exam">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit" :disabled="examTypes.length < 1">Add School Exam</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input school exam name!' }]}]"
            :disabled="examTypes.length < 1"
          />
        </a-form-item>

        <div v-if="examTypes.length < 1" class="py-2">
          <strong class="text-danger">* Please setup exam types first!</strong>
        </div>
        <a-form-item
          v-else
          label="Exam Type"
        >
          <a-spin :spinning="examTypesLoading">
            <a-radio-group
              v-decorator="[
                'exam_type_id',
                {rules: [{ required: true, message: 'Please select a type!' }],},
              ]"
            >
              <a-radio v-for="examType in examTypes" :value="examType.id" :key="examType.id" class="mr-2">
                <span class="text-bold">{{examType.name}}</span>
              </a-radio>
            </a-radio-group>
          </a-spin>
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}"
            v-decorator="['description']"
            :disabled="examTypes.length < 1" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AddSchoolExam',
  mounted: function() {
    this.getExamTypes()
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      examTypesLoading: false,
      examTypes: [],
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    getExamTypes() {
      this.examTypesLoading = true
      this.$http.get('/api/examtype', {
        params: {
          limit: 25,
        },
      }).then(({ data }) => {
        this.examTypesLoading = false
        this.examTypes = data.data
      })
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new school exam!`,
            onOk: () => {
              this.$http
                .post('/api/exam', {
                  name: values.name,
                  description: values.description,
                  exam_type_id: values.exam_type_id,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'School Exam successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
